/**
 * Who sees the "Book Now, Pay Later" controls.
 *
 * THIS IS COSMETIC. It decides which button to render; it authorises nothing. The server
 * re-runs every check (feature flag from the `options` table, isPro, role, impersonation,
 * suspension) and is the only thing that decides. A client that lies to itself here just
 * gets a 403.
 *
 * ── KEEP IN SYNC WITH THE BACKEND ──────────────────────────────────────────────────
 * The authoritative list is PAY_LATER_ROLES in guydeez-backend/app/utils/payLater.util.js.
 *
 * Cette restriction n'est plus figee : l'option `OPT-PAY-LATER-OPEN-TO-ALL-PRO`
 * (ecran des options du back-office) l'ouvre a tout compte marque Pro. Elle se lit
 * avec `usePayLaterOpenToAllPro()` et se passe en second argument — sans quoi le
 * serveur autoriserait une agence a qui l'interface ne montre aucun bouton.
 *
 * Le defaut reste la restriction : un appelant qui ne passe rien obtient le
 * comportement d'avant.
 *
 * `isPro` seul n'est pas une autorisation — il est declare par le compte lui-meme sur
 * la route publique d'inscription, alors qu'un role est accorde par un administrateur.
 * Ouvrir l'option, c'est accepter cette exposition ; les garde-fous serveur (liste
 * blanche, plafonds, coupe-circuit) restent la vraie protection.
 */
export const PAY_LATER_ROLE_IDS: number[] = [1, 2];

// The role reaches the client sometimes as a number, sometimes as its label, depending on
// the auth path — the rest of the app already guards against this the same way.
const PAY_LATER_ROLE_LABELS: string[] = ["Super Admin", "Admin"];

export function isPayLaterEligible(user: any, openToAllPro: boolean = false): boolean {
  if (!user || user.isPro !== true) return false;
  if (openToAllPro) return true;
  const role = user.role;
  if (typeof role === "number") return PAY_LATER_ROLE_IDS.includes(role);
  if (typeof role === "string") {
    const asNumber = Number(role);
    if (Number.isFinite(asNumber)) return PAY_LATER_ROLE_IDS.includes(asNumber);
    return PAY_LATER_ROLE_LABELS.includes(role);
  }
  // Some screens carry an array of role labels rather than a single value.
  if (Array.isArray(role)) return role.some((r) => PAY_LATER_ROLE_LABELS.includes(r));
  return false;
}
